<td colspan="8">
  <div class="d-flex justify-content-center align-items-center">
    <order-zero-confirm-cancelation
      [orderToCancel]="order"
      (orderCanceled)="canceled.emit(true)"
      (orderCancelAborted)="canceled.emit(false)"
    />
  </div>
</td>
